import { JobGroupBudgetEntry } from 'hooks/apiHooks/useJobGroupBudgetEntries';
import { privateApi } from 'services';
import {
    CreateJobGroupBudgetEntry,
    JobGroupBudgetEntryBasic,
    JobGroupBudgetEntryFull,
    UpdateJobGroupBudgetEntry,
} from './types';

const createJobGroupBudgetEntry = async (
    jobGroupId: string,
    BudgetEntry: CreateJobGroupBudgetEntry,
): Promise<JobGroupBudgetEntry> =>
    privateApi.post<JobGroupBudgetEntry>(`job-groups/${jobGroupId}/budget/entries`, BudgetEntry);

const updateJobGroupBudgetEntry = async (
    jobGroupId: string,
    BudgetEntryId: string,
    BudgetEntry: UpdateJobGroupBudgetEntry,
): Promise<JobGroupBudgetEntry> =>
    privateApi.put(`job-groups/${jobGroupId}/budget/entries/${BudgetEntryId}`, BudgetEntry);

const fetchJobGroupBudgetBasic = async (jobGroupId: string): Promise<JobGroupBudgetEntryBasic[]> =>
    privateApi.get<JobGroupBudgetEntry[]>(`job-groups/${jobGroupId}/budget/entries/basic`);

const fetchJobGroupBudgetFull = async (jobGroupId: string): Promise<JobGroupBudgetEntryFull[]> =>
    privateApi.get<JobGroupBudgetEntryFull[]>(`job-groups/${jobGroupId}/budget/entries/full`);

export const JobGroupBudgetGateway = {
    fetchJobGroupBudgetBasic,
    fetchJobGroupBudgetFull,
    createJobGroupBudgetEntry,
    updateJobGroupBudgetEntry,
};
